import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = {
  home: 'https://www.nstl.gov.cn/',
  libcode: 'CN000000',
  selfservice: 'https://selfservice.nstl.gov.cn/',
  userInfo: null,
  isExternal: false,
  isDrainage: false, //用户是有引流优惠额度
  //  articleType: 'J01,J02,J03,Z01', //可优惠的文献类型
  articleCount: 0, //可优惠篇数
  isLogin: false,
  libInfo: [
    { name: '中心站', code: 'CN000000' },
    { name: '南京服务站', code: 'CN112006' },
    { name: '西安服务站', code: 'CN112007' },
    { name: '郑州服务站', code: 'CN112008' },
    { name: '兰州服务站', code: 'CN112005' },
    { name: '昆明服务站', code: 'CN112004' },
    { name: '哈尔滨服务站', code: 'CN112002' },
    { name: '杭州服务站', code: 'CN112003' },
    { name: '成都服务站', code: 'CN112001' },
    { name: '兰白试验区服务站', code: 'CN113064' },
    { name: '黑龙江科技大学', code: 'CN113062' },
    { name: '中国科学院上海生命科学信息中心', code: 'CN113061' },
    { name: '乌鲁木齐服务站', code: 'CN113002' },
    { name: '南宁服务站', code: 'CN113001' },
    { name: '西北农林科技大学', code: 'CN113060' },
    { name: '西安电子科技大学', code: 'CN113053' },
    { name: '长江水利委员会长江科学院', code: 'CN113033' },
    { name: '福州服务站', code: 'CN113024' },
    { name: '武汉东湖服务站', code: 'CN113022' },
    { name: '嘉兴学院', code: 'CN113052' },
    { name: '陕西省科技资源中心', code: 'CN113051' },
    { name: '西安建筑科技大学', code: 'CN113039' },
    { name: '泰达服务站', code: 'CN113013' },
    { name: '合肥服务站', code: 'CN113011' },
    { name: '西安石油大学', code: 'CN113038' },
    { name: '沈阳服务站', code: 'CN113037' },
    { name: '呼和浩特服务站', code: 'CN113036' },
    { name: '中国煤炭科工集团西安研究院', code: 'CN113043' },
    { name: '北京市科学技术研究院', code: 'CN113055' },
    { name: '塔里木大学', code: 'CN113059' },
    { name: '重庆大学', code: 'CN113047' },
    { name: '中原工学院', code: 'CN113048' },
    { name: '成都高新区服务站', code: 'CN113020' },
    { name: '西宁服务站', code: 'CN113009' },
    { name: '交通运输服务站', code: 'CN113015' },
    { name: '中国社会科学院', code: 'CN113058' },
    { name: '银川服务站', code: 'CN113019' },
    { name: '海南服务站', code: 'CN113021' },
    { name: '南昌服务站', code: 'CN113016' },
    { name: '长沙服务站', code: 'CN113018' },
    { name: '贵阳服务站', code: 'CN113040' },
    { name: '深圳服务站', code: 'CN113012' },
    { name: '石家庄服务站', code: 'CN113017' },
    { name: '宁波服务站', code: 'CN113006' },
    { name: '苏州服务站', code: 'CN113010' },
    { name: '新疆兵团服务站', code: 'CN113034' },
    { name: '济宁高新区服务站', code: 'CN113035' },
    { name: '太原服务站', code: 'CN113030' },
    /* { name: '电子科技服务站', code: 'CN113025' }, */
    { name: '澳门科技大学合作馆', code: 'CN113057' },
    { name: '青岛服务站', code: 'CN113007' },
    { name: '河南工业大学', code: 'CN113050' },
    { name: '长春服务站', code: 'CN113014' },
    { name: '武汉服务站', code: 'CN113003' },
    { name: '天津服务站', code: 'CN113004' },
    { name: '苏州大学', code: 'CN113041' },
    { name: '天津科技大学', code: 'CN113056' },
    { name: '上海华谊（集团）公司', code: 'CN113029' },
    { name: '云南农业大学', code: 'CN113054' },
    { name: '济南服务站', code: 'CN113028' },
    { name: '哈尔滨商业大学', code: 'CN113032' },
    { name: '广州服务站', code: 'CN113008' },
    { name: '拉萨服务站', code: 'CN113026' },
    { name: '中医药服务站', code: 'CN113065' },
    { name: '地学服务站', code: 'CN113066' },
    /* { name: '林草服务站', code: 'CN113067' }, */
    { name: '生态环境服务站', code: 'CN113068' },
    { name: '西藏农牧服务站', code: 'CN113069' },
    { name: '雄安服务站', code: 'CN113070' }
  ]
}
const mutations = {
  setHome(state, val) {
    state.home = val.libNetAdd
    state.libcode = val.libCode
  },
  setUser(state, val) {
    state.userInfo = val
    sessionStorage.setItem('uf', JSON.stringify(val))
  },
  setDrainage(state, val) {
    state.isDrainage = val
  },
  setArticleType(state, val) {
    state.articleType = val
  },
  setArticleCount(state, val) {
    state.articleCount = val
  },
  setIsLogin(state, val) {
    state.isLogin = val
  },
  setIsExternal(state, val) {
    state.isExternal = val
  }
}

export default new Vuex.Store({
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/store.js